import React from "react";

function HowToBuy() {
  return (
    <>
      <div className="  relative">
        <div
          id="HowtoBuy"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12 xl:my-20 xl:pt-10 2xl:pt-16  "
        >
          <h2
            className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2 uppercase text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            How to Buy
          </h2>
          <div className="flex flex-wrap lg:flex-row gap-10 sm:gap-7 mt-8 lg:mt-12 xl:mt-16 justify-center">
            <div
              className="w-full sm:w-[45%] md:w-[48%] lg:w-1/3 max-w-[500px]"
              data-aos="flip-left"
              data-aos-duration="1000"
            >
              <div className="p-4 xl:p-6 border border-white bg-white rounded-xl shadow-[0px_10px_0px_0px_#0279E1] h-full">
                <div className="bg-[#0279E1] w-20 h-16 rounded-full flex flex-col justify-center items-center">
                  <p className="text-maladroit text-white text-base sm:text-lg lg:text-xl ">
                    01
                  </p>
                </div>
                <h4 className="text-black text-aircruiser uppercase  text-2xl lg:text-4xl xl:text-[40px] my-3 ">
                  Solana Wallet
                </h4>{" "}
                <p className="text-black text-base sm:text-lg lg:text-xl xl:text-[22px] pb-4">
                  Download your solana wallet of choice but we recommend phantom
                  or solflare chrome extensions.
                </p>
              </div>
            </div>{" "}
            <div
              className="w-full sm:w-[45%] md:w-[48%] lg:w-1/3 max-w-[500px]"
              data-aos="flip-left"
              data-aos-duration="2000"
            >
              <div className="p-4 xl:p-6 border border-white bg-white rounded-xl shadow-[0px_10px_0px_0px_#0279E1] h-full">
                <div className="bg-[#0279E1] w-20 h-16 rounded-full flex flex-col justify-center items-center">
                  <p className="text-maladroit text-white text-base sm:text-lg lg:text-xl ">
                    02
                  </p>
                </div>
                <h4 className="text-black text-aircruiser uppercase  text-2xl lg:text-4xl xl:text-[40px] my-3 ">
                  Get some Solana
                </h4>{" "}
                <p className="text-black text-base sm:text-lg lg:text-xl xl:text-[22px] pb-4">
                  Get some Solana, either buy within your wallet or via an
                  exchange and deposit to your wallet via the address shown.
                </p>
              </div>
            </div>{" "}
            <div
              className="w-full sm:w-[45%] md:w-[48%] lg:w-1/3 max-w-[500px]"
              data-aos="flip-left"
              data-aos-duration="3000"
            >
              <div className="p-4 xl:p-6 border border-white bg-white rounded-xl shadow-[0px_10px_0px_0px_#0279E1] h-full">
                <div className="bg-[#0279E1] w-20 h-16 rounded-full flex flex-col justify-center items-center">
                  <p className="text-maladroit text-white text-base sm:text-lg lg:text-xl ">
                    03
                  </p>
                </div>
                <h4 className="text-black text-aircruiser uppercase  text-2xl lg:text-4xl xl:text-[40px] my-3 ">
                  Buy some $JOSH
                </h4>{" "}
                <p className="text-black text-base sm:text-lg lg:text-xl xl:text-[22px] pb-4">
                  Go to Raydium and paste in the $JOSH Contract address. Select
                  your desired amount and confirm.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HowToBuy;
